export default __webpack_public_path__ + "static/media/search.e5c9d180.svg";